module.exports = __webpack_public_path__ + "img/email.0eebc656.png";